<template>
  <v-container class="mx-2">
    <v-row>
      <v-col cols="12" lg="7">
        <v-breadcrumbs class="pl-0 pt-0" :items="items" />
        <h1 class="mb-8">{{ $route.meta.title }}</h1>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                label="Имя"
                v-model='name'
                prepend-inner-icon="mdi-rename-box-outline"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                label="Email клиента"
                v-model="email"
                prepend-inner-icon="mdi-email"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
              <v-text-field
                label="Телефон"
                v-model='telephone'
                prepend-inner-icon="mdi-phone"
                :rules="[
                  () => /^\d{11}$/.test(telephone) || 'Укажите корректный номер телефона',
                ]"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" class="py-0">
            </v-col>
          </v-row>
          <v-card-actions class="pl-0">
            <div class="my-2">
              <v-btn
                large
                color="success"
                class="text-none"
                @click="validate()"
                :disabled="!valid"
              >
                Сохранить
              </v-btn>
              <v-btn
                @click.prevent="returnListClients()"
                large
                class="ma-2 text-none"
                outlined
                dense
                color="error"
              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'NewAgent',
  data () {
    return {
      valid: true,
      name: '',
      email: '',
      telephone: '',
      items: [
        {
          text: 'Список клиентов',
          disabled: false,
          href: '/list-cliens',
        },
        {
          text: 'Добавление клиента',
          disabled: true,
          href: '#',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      newClient: 'Client/newClient',
    }),
    returnListClients () {
      this.$router.push({ name: 'ListClients' });
    },
    validate () {
      this.$refs.form.validate();
      this.$nextTick(() => {
        if (this.valid) {
          this.newClient({
            name: this.name,
            email: this.email,
            telephone: this.telephone,
          })
            .then(() => {
              this.$router.push({ name: 'ListClients' });
              this.$flash_success('Клиент создан успешно');
            });
        } else {
          this.$flash_warning('Заполните все обязательные поля');
        }
      });
    },
  },
};
</script>
